<template>
    <section class="container margin-both-xl  container--medium container--calcPadding">
        <div v-if="loadingPostsStatus === 'loading'" class="dummy-items">
            <div v-for="i in itemsCount" :key="i" class="dummy-block">
                <DummyLine :height="24" />
                <DummyLine :height="16" :width="60" />
                <DummyLine :height="16" :width="82" />
                <DummyLine :height="16" :width="40" />
            </div>
        </div>

        <template v-if="loadingPostsStatus === 'success' && menuItems.length">
            <MenuBox class="margin-bottom-lg" v-for="(it, k) in menuItems" :key="k" :data="it" />
        </template>

    </section>
</template>

<script>
import DummyLine from '@/components/elements/DummyLine'
import MenuBox from '@/components/elements/MenuBox'

import { mapOrder } from '@/helpers'

import { mapActions } from 'vuex'

export default {
    name: 'menu-list',
    props: ['data'],
    components:{
        DummyLine,
        MenuBox
    },
    data(){
        return {
            menuItems: [],
            itemsCount: 0,
            loadingPostsStatus: 'loading',
        }
    },
    mounted(){
        const VM = this;
        VM.loadingPostsStatus = 'loading'
        VM.itemsCount = VM.data.menu_item.length,
        VM.getPost(VM.loadOpt).then(res=>{
            if(res.data && res.data.posts && res.data.posts.length){
                //console.log(res.data.posts)
                VM.loadingPostsStatus = 'success'
                VM.menuItems = mapOrder(res.data.posts, VM.data.menu_item, 'id');
                //mapOrder(res.data.posts, VM.data.menu_item, 'id')
                //console.log()
            }else{
                VM.loadingPostsStatus = 'notFound'  
            }
        })
    },
    computed:{
        loadOpt(){
            const VM = this;
            const opt = {
                type: 'menuitems',
                limit : VM.itemsCount,
                include: VM.data.menu_item
            }

            return opt;
        }
    },
    
    methods:{
		...mapActions([
			'getPost',
        ]),
    }
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-menu_list{
    .dummy-block{
        background: $yellowLighten;
        padding: 25px;
        margin-bottom: 50px;
    }
}
</style>